<div class="upload-section">
  <p-fileUpload
    [disabled]="isUploading"
    [mode]="'basic'"
    multiple
    chooseLabel="Selecione as imagens"
    chooseIcon="pi pi-plus"
    accept=".png, .jpg, .jpeg, .webp"
    (onSelect)="onFileSelected($event)"
    id="imagesUpload"
    #imagesUpload
    name="imagesUpload[]"
    [customUpload]="true"
    invalidFileTypeMessageSummary="{0}: Arquivo inválido,"
    invalidFileTypeMessageDetail="Apenas arquivos PNG, JPG, JPEG, WEBP são permitidos"
  />

  <p-button
    *ngIf="imagesPreview.length || productsNotFound.length"
    [disabled]="isUploading"
    severity="danger"
    label="Limpar"
    icon="pi pi-ban"
    iconPos="left"
    (onClick)="clearBatchUpdate()"
  />

  <p-button
    *ngIf="imagesPreview.length || productsNotFound.length"
    [disabled]="!canUpload || isUploading"
    styleClass="p-button-info"
    label="Upload"
    icon="pi pi-upload"
    iconPos="left"
    (onClick)="upload()"
  />
</div>

<div class="preview-resume">
  <ol>
    <li>
      Selecione todos os arquivos para realizar upload. Apenas formato PNG, JPG,
      JPEG e WEBP são permitidos.
    </li>
    <li>
      O nome do arquivo deve conter o EAN do produto, seguido por um caractere
      underline e a numeração da imagem: Exemplo: 0987654321_1.png,
      0987654321_2.png
    </li>
    <li>
      Produtos <b>não encontrados</b> ou com numeração incorreta
      <b>não serão atualizados</b>.
    </li>
    <li>
      Os arquivos que já estão no storage com o mesmo nome serão sobrescritos.
    </li>
    <li>
      Após carregar as imagens, para visualizá-las em tamanho real, basta clicar
      na mesma.
    </li>
  </ol>
</div>

<div>
  <div class="preview-progress" *ngIf="imagesPreview.length">
    <div class="preview-progress-bar">
      <p-progressBar
        [value]="uploadProgress"
        [showValue]="true"
        [style]="{ height: '20px' }"
      >
      </p-progressBar>
    </div>
    <div class="preview-progress-message" *ngIf="uploadProgress === 100">
      <p-message
        [severity]="'success'"
        [text]="
          'Upload realizado com sucesso. Aguarde o pós processamento da imagens e em alguns minutos os produtos serão atualizados.'
        "
      />
    </div>
  </div>

  <div
    class="preview-resume"
    *ngIf="imagesPreview.length || productsNotFound.length"
  >
    <ul>
      <li>Produtos não encontrados: {{ productsNotFound.length }}</li>
      <li class="preview-resume-info" *ngIf="productsNotFound.length">
        <span *ngFor="let ean of productsNotFound">{{ ean + ', ' }} </span>
      </li>
      <li>Produtos fora de ordem: {{ invalidProducts.length }}</li>
      <li class="preview-resume-info">
        <span *ngFor="let prod of invalidProducts">{{ prod.ean + ', ' }} </span>
      </li>
      <li>
        Produtos encontrados a serem atualizados: {{ validProducts.length }}
      </li>
    </ul>
  </div>

  <ng-container *ngFor="let product of imagesPreview">
    <div class="preview-section">
      <div class="preview-section-title">
        <span>{{ product.ean }} - {{ product.name }}</span>
        <span *ngIf="!product.valid">
          <p-badge
            class="badge-warn"
            [value]="'Numeração invalida'"
            severity="danger"
          />
        </span>
      </div>

      <div class="preview-section-images">
        <div
          class="preview-section-images-item"
          *ngFor="let image of product.images; let index = index"
        >
          <p-image
            [src]="image.thumbnailImageSrc"
            [alt]="image.alt"
            width="100"
            [preview]="true"
          />
        </div>
      </div>
    </div>
  </ng-container>
</div>
